// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon from '../Icon';

import './Toast.less';

const INFO = 'info';
const SUCCESS = 'success';
const WARNING = 'warning';
const DANGER = 'danger';

const icons = {
    [INFO]: 'circle-info-filled',
    [SUCCESS]: 'circle-check-mark-filled',
    [WARNING]: 'circle-exclamation-mark-filled',
    [DANGER]: 'circle-exclamation-mark-filled',
};

const Toast = ({ baseClassName, className, message, intent, onClose, ...props }) => (
    <div tabIndex="0" className={classNames(baseClassName, `${baseClassName}--${intent}`, className)} {...props}>
        <span className={`${baseClassName}__icon`}>
            <Icon name={icons[intent]} />
        </span>
        <span className={`${baseClassName}__content`}>
            {message}
        </span>
        <span className={`${baseClassName}__action`}>
            <button className={`${baseClassName}__close`} type="button" onClick={onClose}>
                <Icon name="cross-mark" className={`${baseClassName}__close-x`} />
            </button>
        </span>
    </div>
);
Toast.propTypes = {
    /**
     * Visual intent color to apply to component.
     */
    intent: PropTypes.oneOf(['info', 'success', 'warning', 'danger']).isRequired,
    message: PropTypes.any,
    onClose: PropTypes.func,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Toast.defaultProps = {
    message: null,
    onClose: null,
    className: null,
    baseClassName: `${CLS_PREFIX}toast`,
};

export default Toast;



// WEBPACK FOOTER //
// ./components/Toast/Toast.js